import * as React from 'react'

import { Badge } from '../../../components'
import { SubMenuTabs } from '../../../components/SubMenu/SubMenuTabs'
import { INSIDER_VIEW_LABELS, InsiderView } from '../constants'
import { useInsiderTradingRouter } from '../hooks/useInsiderTradingRouter'

const MENU_TABS: Array<keyof typeof INSIDER_VIEW_LABELS> = [InsiderView.Index, InsiderView.Managers, InsiderView.Funds]
const MENU_TABS_MAP = {
  [InsiderView.Managers]: InsiderView.Managers,
  [InsiderView.ManagerDetails]: InsiderView.Managers,
  [InsiderView.ManagerHoldings]: InsiderView.Managers,
  [InsiderView.Funds]: InsiderView.Funds,
  [InsiderView.FundDetails]: InsiderView.Funds,
  [InsiderView.FundHoldings]: InsiderView.Funds,
}
const MANAGER_FUNDS_VIEWS = [
  InsiderView.Managers,
  InsiderView.ManagerDetails,
  InsiderView.ManagerHoldings,
  InsiderView.Funds,
  InsiderView.FundDetails,
  InsiderView.FundHoldings,
]

export function Navigation() {
  const insiderTradingRouter = useInsiderTradingRouter()
  const activeView = (insiderTradingRouter.viewParams.view as InsiderView) || InsiderView.Index
  const isIndexPage = activeView === InsiderView.Index
  const menuItems = React.useMemo(
    () =>
      MENU_TABS.map((view) => ({
        label: INSIDER_VIEW_LABELS[view],
        href: insiderTradingRouter.getInsiderTradingLink({ view }),
        isActive: isIndexPage
          ? view === InsiderView.Index
          : MENU_TABS_MAP[activeView as keyof typeof MENU_TABS_MAP] === view,
        reloadDocument: true,
      })),
    [activeView, insiderTradingRouter, isIndexPage]
  )

  return (
    <>
      <SubMenuTabs size="xlarge" items={menuItems} />
      {!isIndexPage && MANAGER_FUNDS_VIEWS.includes(activeView) ? (
        <Badge size="small" className="ml-2" active>
          Beta
        </Badge>
      ) : null}
    </>
  )
}
